import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/Drawer.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/framer-link.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/layout/Container.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/layout/Header.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/layout/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/layout/smooth-scroll.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ProjectCard.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/Projects.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/card.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/halo.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/marquee.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/particles.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/components/ui/stars.tsx");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/node_modules/.pnpm/next@15.1.1_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/mehdi/Desktop/portfolio-v2/util/helpers.tsx");
